module.exports = __webpack_public_path__ + "media/images/svg/linkedin-7defd339fd92d3e5fa034b24a5f10ed6.svg";